<template>
  <div id="all">
    <div v-if="isModify">
      <el-input
        v-model="address_detail"
        size="small"
        style="width: 380px; margin-bottom: 10px"
        id="suggestId"
        name="address_detail"
        placeholder="地址"
        class="input_style"
      />
      <div style="color: #999999">
        <i class="el-icon-info" style="color: #1362FF; margin-right: 5px"></i
        >输入地址后，需要在地图上点击具体位置方可定位
      </div>
    </div>
    <div v-else>{{ defaultAdd }}</div>
    <div id="allmap"></div>
  </div>
</template>

<script>
// import BMap from 'BMap'
export default {
  name: "garden-map",
  props: {
    isModify: Boolean,
    defaultAdd: String,
    longitude: String,
    latitude: String,
  },
  data() {
    return {
      //详细地址
      address_detail: null,
      userlocation: {
        lng: "",
        lat: "",
      },
      map: null,
    };
  },

  mounted() {
    this.$nextTick(function () {
      let th = this;
      // 创建Map实例
      let map = new BMap.Map("allmap");
      this.map = map;
      // 初始化地图,设置中心点坐标，

      let x = +this.longitude;
      let y = +this.latitude;

      let point = new BMap.Point(x, y);
      // // 创建点坐标
      this.map.centerAndZoom(point, 15);
      this.map.enableScrollWheelZoom();

      let mk = new BMap.Marker({
        lng: x,
        lat: y,
      });
      console.log(111);
      this.map.addOverlay(mk);
      this.map.panTo({
        lng: x,
        lat: y,
      });
      //建立一个自动完成的对象
      let ac = new BMap.Autocomplete({
        input: "suggestId",
        location: map,
      });

      let myValue;
      //鼠标点击下拉列表后的事件
      ac.addEventListener("onconfirm", function (e) {
        let _value = e.item.value;
        myValue =
          _value.province +
          _value.city +
          _value.district +
          _value.street +
          _value.business;
        th.address_detail = myValue;
        setPlace();
      });

      function setPlace() {
        //清除地图上所有覆盖物
        map.clearOverlays();
        function myFun() {
          //获取第一个智能搜索的结果
          th.userlocation = local.getResults().getPoi(0).point;
          map.centerAndZoom(th.userlocation, 18);
          //添加标注
          let newMk = new BMap.Marker(th.userlocation);
          map.addOverlay(newMk);
        }

        //智能搜索
        let local = new BMap.LocalSearch(map, {
          onSearchComplete: myFun,
        });

        local.search(myValue);

        //测试输出坐标（指的是输入框最后确定地点的经纬度）
        map.addEventListener("click", function (e) {
          th.$emit(
            "getAddress",
            th.address_detail,
            th.userlocation.lng,
            th.userlocation.lat
          );
        });
      }
    });
  },
  watch: {
    defaultAdd(val) {
      this.address_detail = val;
    },
    longitude(val) {
      if (this.map) {
        this.$nextTick(function () {
          let x = +this.longitude;
          let y = +this.latitude;

          let point = new BMap.Point(x, y);
          // 创建点坐标
          this.map.centerAndZoom(point, 15);
          this.map.enableScrollWheelZoom();

          let mk = new BMap.Marker({
            lng: x,
            lat: y,
          });
          this.map.addOverlay(mk);

          /*this.map.panTo({
              lng: x,
              lat: y
            });*/
        });
      }
    },
    // longitude () {
    //   if (this.longitude && this.latitude) {
    //     let map = new BMap.Map("allmap");
    //     let x = +this.longitude
    //     let y = +this.latitude
    //     let point = new BMap.Point(x, y);
    //     // 创建点坐标
    //     map.centerAndZoom(point, 15);
    //     map.enableScrollWheelZoom();
    //     let mk = new BMap.Marker({
    //       lng: x,
    //       lat: y
    //     });
    //     map.addOverlay(mk)
    //   }
    // }
  },
};
</script>

<style>
#allmap {
  width: 680px;
  height: 240px;
  left: -140px;
}
.anchorBL {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Map/GardenMap.vue